import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-shell',
    imports: [CommonModule, RouterModule, ToastModule, MenuComponent],
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss']
})
export class ShellComponent {}
